import React, { useState } from "react";
import {
  Form,
  Modal,
  notification,
  DatePicker,
  Button,
  InputNumber,
  Row,
  Col,
  AutoComplete,
} from "antd";

import axiosInstance from "../../../utilities/axios";

const NewFinancingModal = ({
  visible,
  onChange,
  onClose,
  financingOptionNames = [],
}) => {
  const [form] = Form.useForm();

  const [options, setOptions] = useState([]);

  const handleSearch = (searchText) => {
    if (!searchText) {
      setOptions([]);
    } else {
      const filtered = financingOptionNames
        .filter((name) => name.toLowerCase().includes(searchText.toLowerCase()))
        .map((name) => ({ value: name }));
      setOptions(filtered);
    }
  };
  const onSubmit = (values) => {
    axiosInstance
      .post("/financing-options", {
        name: values.name,
        term_length: values.term_length,
        interest_rate: values.interest_rate,
        down_payment: values.down_payment,
        start_date: values.start_date.format("YYYY-MM-DD"),
        end_date: values.end_date ? values.end_date.format("YYYY-MM-DD") : null,
      })
      .then((response) => {
        notification.success({
          message: "Success",
          description: "Financing option added successfully",
        });
        onChange();
        onClose();
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: "Failed to add financing option",
        });
      });
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={visible}
      title="Add New Financing Option"
      onCancel={handleClose}
      onOk={() => form.submit()}
      footer={
        <>
          <Button key="back" onClick={handleClose}>
            Cancel
          </Button>
          <Button key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Button>
        </>
      }
    >
      <Form
        form={form}
        name="newFinancingOption"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item
          name="name"
          label="Financing Option Name"
          rules={[
            {
              required: true,
              message: "Please enter the financing option name",
            },
          ]}
        >
          <AutoComplete
            defaultActiveFirstOption
            options={options}
            onSearch={handleSearch}
            backfill
            placeholder="Enter financing option name"
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
          />
        </Form.Item>
        <Form.Item
          name="term_length"
          label="Term Length"
          rules={[{ required: true, message: "Please enter the term length" }]}
        >
          <InputNumber
            placeholder="Enter term length"
            suffix="months"
            style={{ width: "100%" }}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name="interest_rate"
          label="Interest Rate"
          rules={[
            { required: true, message: "Please enter the interest rate" },
          ]}
        >
          <InputNumber
            placeholder="Enter interest rate"
            suffix="%"
            style={{ width: "100%" }}
            max={100}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name="down_payment"
          label="Minimum Down Payment"
          rules={[
            {
              required: true,
              message: "Please enter the minimum down payment",
            },
          ]}
        >
          <InputNumber
            placeholder="Enter minimum down payment"
            suffix="%"
            style={{ width: "100%" }}
            max={100}
            min={0}
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="start_date"
              label="Start Date"
              rules={[
                { required: true, message: "Please select a start date" },
              ]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="end_date" label="End Date">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default NewFinancingModal;
